module.exports = __webpack_public_path__ + "static/media/keep-austin-social.21141362.jpg";